import apiWrapper from '../../services/apiWrapper';

const unsubscribeFromNewsletter = async (email) => {
  try {
    const response = await apiWrapper('post', '/unsubscribe', { email });
    return {
      success: response.success,
      message: response.message
    };
  } catch (error) {
    console.error('Error:', error.message);
    return {
      success: false,
      message: error.message || 'An error occurred. Please try again later.'
    };
  }
};

export default unsubscribeFromNewsletter;